export default __webpack_public_path__ + "static/media/46596b99b1596dd7ca748dbf9300374f1577969948216.fc3fa4f4.webp";